import { Dialog, DialogContent, DialogTitle, IconButton, Tooltip, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { SiTrackGrid } from '../../components/si-track-grid/si-track-grid';
import { UserPermissionName } from '../../models/user-permission-name';
import { fileColumns } from './grid-columns';
import { fileUploadApiKeyStore } from '../../api/file-upload-key-store';
import { useSaveData } from '../../hooks/useSaveData';

interface FileDownloadDialog {
  queueData: any;
  onClosed: () => void;
}

const downloadBlob = (blob: Blob, fileName: string) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

const handleFileFunctionality = (fileResponse: any, fileData: any) => {
  if (fileResponse) {
    if (typeof fileResponse === 'string') {
      const blob = new Blob([new Uint8Array(
        Array.from(atob(fileResponse), (char) => char.charCodeAt(0)))],
        { type: fileData?.fileType });
      downloadBlob(blob, fileData?.fileName ?? 'file');
    } else {
      throw new Error('Invalid data type for file download.');
    }
  }
}

export const FileDownloadDialog = ({ queueData, onClosed }: FileDownloadDialog) => {

  const { isLoading: isFilesLoading, mutateAsync: mutateFileAsync } = useSaveData<any>(fileUploadApiKeyStore.downloadFFExceptionFile());

  const handleDownloadFile = async (data: any) => {
    const filePayload = {
      fileid: data?.fileID,
      fileSection: "file"
    }
    const fileResponse = await mutateFileAsync({ data: filePayload });
    handleFileFunctionality(fileResponse, {
      fileName: data?.fileName,
      fileType: data?.fileType
    });
  };

  return (
    <Dialog
      open={true}
      fullWidth={true}
      maxWidth={'xl'}
      // onClose={onClosed}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" sx={{ p: 2, pt: 1, pb: 1, m: 0 }}>
        VIEW / DOWNLOAD PDF
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClosed}
        sx={{
          position: 'absolute',
          right: 10,
          top: 3,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Tooltip title={<Typography variant="body1">Close</Typography>}>
          <CloseIcon />
        </Tooltip>
      </IconButton>
      <DialogContent dividers className="popupDilog">
        <SiTrackGrid
          fileTitle='workorder_file'
          dataItemKey="fileID"
          columns={fileColumns}
          queryConfig={fileUploadApiKeyStore.getFFExceptionFileList(queueData?.queueID, queueData?.workOrderNumber)}
          onDownload={(data: any) => {
            handleDownloadFile(data);
          }}
          actionPermissions={{
            export: UserPermissionName.DOWNLOAD_GRID,
            download: UserPermissionName.DOWNLOAD_FILE,
          }}
          isBusy={isFilesLoading}
        />
      </DialogContent>
    </Dialog>
  );
};
